import Vue from 'vue'
import Vuex from 'vuex'

import Vue2TouchEvents from 'vue2-touch-events'
import PortalVue from 'portal-vue'
import VueI18n from 'vue-i18n'

import '@/common/assets/base.less'
import '@/common/assets/fonts/proximanova/proximanova.less'

import messages from '@/common/locales/messages'
import px from '@/common/filters/px'
import percent from '@/common/filters/percent'
import formatTime from '@/common/filters/formatTime'

import DevPlayground from './DevPlayground.vue'
import main from '@/common/shared.main'
import getEnvVars from '@/common/utils/getEnvVars'

const { API_HOST } = getEnvVars()

function redirect() {
  const redirectTo = {
    'lumiere-develop.firebaseapp.com': 'dev.player.lumiere.is',
    'lumiere-staging.firebaseapp.com': 'stage.player.lumiere.is',
    'lumiere-production.firebaseapp.com': 'player.lumiere.is',
  }[location.host]
  if (redirectTo) {
    location.href = `https://${redirectTo}${location.pathname}${
      location.search
    }`
  }
}

function initVue() {
  Vue.use(Vue2TouchEvents, { touchClass: 'touching' })
  Vue.use(PortalVue)
  Vue.use(VueI18n)
  Vue.use(Vuex)

  Vue.filter('px', px)
  Vue.filter('percent', percent)
  Vue.filter('formatTime', formatTime)

  Vue.config.productionTip = false
}

function dev() {
  initVue()
  const i18n = new VueI18n({
    locale: localStorage.locale || 'en',
    messages,
  })

  new Vue({
    i18n,
    render: h =>
      h(DevPlayground, {
        props: {
          API_HOST,
        },
      }),
  }).$mount('#app')
}
redirect()
main()
window.main = dev
